import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import date from './date.js'
import time from './time.js'

export default contract({
  date: array([
    date
  ]),
  time: array([
    time
  ])
})
